import { authorizedInstance } from "../config/axios"

export const getMissingPathologyLogStats = async ({ sortBy, filters }) => {
  const query = new URLSearchParams({
    sortBy,
    ...filters,
  })
  const response = await authorizedInstance.get(
    `/missing-pathology-logs/stats?${query}`
  )
  return response.data
}

export const getMissingPathologyLogsByMissingPathology = async ({
  page,
  limit,
  sortBy,
  filters,
}) => {
  const query = new URLSearchParams({
    page,
    limit,
    sortBy,
    ...filters,
  })

  const response = await authorizedInstance.get(
    `/missing-pathology-logs?${query}`
  )
  return response.data
}

export const getMissingPathologyLogByLogId = async (missingPathologyLogId) => {
  const response = await authorizedInstance.get(
    `/missing-pathology-logs/log/${missingPathologyLogId}`
  )
  return response.data
}

export const getDistinctBodyParts = async () => {
  const response = await authorizedInstance.get(
    `/missing-pathology-logs/body-parts`
  )
  return response.data
}
